import { record, type Row } from '../janus-engine/ability/context';
import { deathInputMemberIds } from '../janus-engine/death/input-members';
import { deathDutyName } from '../janus-engine/death/skip';
import { awaitEntityBaseReady } from './entity-compile-ready';

/** Join only linked holders before the ability frame/dice. An unrelated refused row
 * stays untouched; a required holder's existing refusal identifies that creature. */
export async function awaitDeathLinkedInputs(roots: readonly string[], current: {
    encounter: () => Row | null; member: (id: string) => Row | null;
}): Promise<string | null> {
    const ready = new Set(roots.map(id => id.toUpperCase()));
    for (;;) {
        const held = current.encounter();
        if (!held) return 'death:entity-base-unavailable:Encounter:base-not-held';
        const ids = deathInputMemberIds(held, roots).filter(id => !ready.has(id));
        if (!ids.length) return null;
        const results = await Promise.all(ids.map(async id => ({ id, ok: await awaitEntityBaseReady([id], false) })));
        const failed = results.find(result => {
            const member = current.member(result.id);
            return !result.ok || !record(record(member?.computed)?.creature) || !record(member?.item_layer_types);
        });
        if (failed) {
            const member = current.member(failed.id);
            const name = member ? deathDutyName(member) : 'Creature';
            return `death:entity-base-unavailable:${name} (${failed.id}):${String(member?._entity_refusal ?? 'base-not-held')}`;
        }
        ids.forEach(id => ready.add(id));
    }
}
